import { ApolloError } from "@apollo/client";

function handleApolloErrorLog(error: ApolloError) {
  if (process.env.NODE_ENV === "development") {
    console.log(error);
  }
}

export default handleApolloErrorLog;
